import useFirebaseData from "./useFirebaseData";
import type { FirebaseRecord, Segment } from "../types";

const useSharedFirebaseSegments = (sharing_user_id: string) => {
  return useFirebaseData<FirebaseRecord<Segment>>(
    sharing_user_id ? `/shared_userdata/${sharing_user_id}/segments` : null
  );
};

export default useSharedFirebaseSegments;
